/**
 * Avis Google de Suro Phone.
 * `ville` = slug de la commune du client (voir data/villes.js) ou null si inconnue.
 * Pour ajouter un vrai avis : copier une ligne, remplacer name / text / date / ville.
 */
export const AVIS = [
  { initial: 'M', color: 'blue', name: 'Marc D.', ville: null, date: 'Il y a 2 semaines', rating: 5, text: "Écran de mon iPhone 12 changé en 1h chrono ! Travail impeccable, prix honnête. Je recommande à 100%, merci Suro Phone !" },
  { initial: 'S', color: 'pink', name: 'Sophie L.', ville: 'saint-chamond', date: 'Il y a 1 mois', rating: 5, text: "Batterie Samsung Galaxy changée rapidement à Saint-Chamond. Professionnel, à l'écoute et de très bons conseils. Très satisfaite du service !" },
  { initial: 'A', color: 'green', name: 'Ahmed K.', ville: 'saint-chamond', date: 'Il y a 3 semaines', rating: 5, text: "Excellent service ! Mon téléphone est comme neuf. Garantie 3 mois, c'est rassurant. Un vrai professionnel à Saint-Chamond. Merci beaucoup !" },
  { initial: 'C', color: 'purple', name: 'Camille R.', ville: null, date: 'Il y a 1 semaine', rating: 5, text: "Vitre arrière de mon iPhone 13 remplacée en moins de 30 minutes. Accueil chaleureux, tarif clair annoncé à l'avance, rien à redire !" },
  { initial: 'T', color: 'orange', name: 'Thomas B.', ville: null, date: 'Il y a 2 mois', rating: 5, text: "Suro Phone m'a sauvé la vie ! iPhone tombé dans l'eau, récupéré intact le lendemain. Diagnostic gratuit et prix imbattable. Je recommande vivement." },
  { initial: 'J', color: 'indigo', name: 'Julie P.', ville: null, date: 'Il y a 5 jours', rating: 5, text: "Connecteur de charge de mon iPhone 14 réparé parfaitement. Service rapide et soigné, vraiment un super artisan local. Je reviendrai !" },
];

export const GOOGLE_REVIEWS_URL = 'https://share.google/PHMyc4K1Px9kMzRxQ';
export const NOTE_GOOGLE = '5.0';
export const NB_AVIS_GOOGLE = '370';
export const ADRESSE = '40 rue de la République, 42400 Saint-Chamond';
export const MAPS_URL = 'https://www.google.com/maps/dir//40+rue+de+la+R%C3%A9publique,+42400+Saint-Chamond';

export const COLOR_MAP = {
  blue: 'bg-blue-100 text-blue-600',
  pink: 'bg-pink-100 text-pink-600',
  green: 'bg-green-100 text-green-600',
  purple: 'bg-purple-100 text-purple-600',
  orange: 'bg-orange-100 text-orange-600',
  indigo: 'bg-indigo-100 text-indigo-600',
};

/** Avis d'une commune, sinon des communes voisines (par distance), sinon avis généraux. */
export const avisPourVille = (ville, voisines = [], n = 2) => {
  const locaux = AVIS.filter((a) => a.ville === ville.slug);
  if (locaux.length >= n) return { avis: locaux.slice(0, n), local: true };
  const slugsVoisins = voisines.map((v) => v.slug);
  const proches = AVIS.filter((a) => a.ville && a.ville !== ville.slug && slugsVoisins.includes(a.ville));
  const atelier = AVIS.filter((a) => a.ville === 'saint-chamond' && ville.slug !== 'saint-chamond');
  const generaux = AVIS.filter((a) => !a.ville);
  const reste = [...proches, ...atelier, ...generaux].filter((a, i, arr) => !locaux.includes(a) && arr.indexOf(a) === i);
  return { avis: [...locaux, ...reste].slice(0, n), local: locaux.length > 0 };
};
